import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            关于密桃视频使用，您可能想了解的问题
          </p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}